import styled from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'

const tabletViewBreakpoint = '1400px'

const AbsoluteWrapper = styled.div`
  position: absolute;
  bottom: ${({ bottom }) => (bottom ? bottom : 'unset')};
  top: ${({ top }) => (top ? top : 'unset')};
  right: ${({ right }) => (right ? right : 'unset')};
  left: ${({ left }) => (left ? left : 'unset')};
  width: calc(100% + 40px);
  left: -20px;
  border: 1px solid ${colors.grey80};
  background-color: ${colors.white};
  box-shadow: 0px 16px 32px -8px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  z-index: 1;

  @media screen and (max-width: ${tabletViewBreakpoint}) {
    left: 0;
    width: 100%;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 40px;
  @media only screen and (max-width: ${tabletViewBreakpoint}) {
    padding: 26px;
  }

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    padding: 40px;
  }

  @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 26px;
  }
`

const LogoWrapper = styled.div`
  margin-bottom: 20px;
`

const Title = styled.div`
  font-size: 24px;
  font-weight: ${fontWeights.bold};
  line-height: 32px;
  margin-bottom: 8px;
  text-align: center;

  @media only screen and (max-width: ${tabletViewBreakpoint}) {
    font-size: 20px;
  }
`

const ContentContainer = styled.div`
  width: 100%;
`

const FloatingModal = ({
  logo = 'LOGO',
  title = 'UNLOCK TRUST SCORE',
  children,
  top,
  bottom,
  right,
  left
}) => {
  return (
    <AbsoluteWrapper top={top} bottom={bottom} right={right} left={left}>
      <Container>
        {logo && <LogoWrapper>{logo}</LogoWrapper>}
        {title && <Title>{title}</Title>}
        <ContentContainer>{children}</ContentContainer>
      </Container>
    </AbsoluteWrapper>
  )
}

export default FloatingModal
